const getters = {
  menu: state => state.menu.menu,
  website: state => state.common.website,
  is_collapse: state => state.menu.is_collapse,
  default_open_menu: state => state.menu.default_open_menu,
  size: state => state.app.size,
  appLoading: state => state.app.appLoading,
  token: state => state.app.token,
  resetPassword: state => state.app.resetPassword,
  msg: state => state.appstore.msg,
  tagList: state => state.tags.tagList,
  tagWel: state => state.tags.tagWel,
  tag: state => state.tags.tag,
  resetCode: state => state.app.resetCode,
  setNewOpen: state => state.app.setNewOpen,
};

export default getters;
